import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { TrackSeoLinksClick } from '@app/+catalog/store';

/**
 * When the user click on seo links.
 */
const events = getEvents(({ payload: { position, label, url } }: TrackSeoLinksClick) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'seoInternalLink',
      link_position: position,
      link_anchor: label,
      link_url: url,
      env_template: 'catalog'
    }
  }
]);

export default events;
